import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';

import useStyles from './useStyles';
import ListItem from './ListItem';

const List = forwardRef(
  ({ dense, interactive, noRules, transparent, children, role, id }, ref) => {
    const theme = useTheme();
    const { wrenchList } = useStyles({
      dense,
      interactive,
      noRules,
      transparent,
      theme,
    });

    const newChildren = React.Children.map(
      children,
      (child, index) =>
        React.isValidElement(child) &&
        React.cloneElement(child, { interactive, index })
    );

    return (
      <ul ref={ref} className={wrenchList} role={role} id={id}>
        {newChildren}
      </ul>
    );
  }
);

List.propTypes = {
  /**
   * Composed of List.Item
   */
  children: PropTypes.node.isRequired,
  /**
   * Reduce child List.Item height and font-weight
   */
  dense: PropTypes.bool,
  /**
   * Unique identifier for list
   */
  id: PropTypes.string,
  /**
   * Add hover style to all children List.Item,
   */
  interactive: PropTypes.bool,
  /**
   * Remove divider lines between List.Item
   */
  noRules: PropTypes.bool,
  /**
   * Define aria role - https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/List_role
   */
  role: PropTypes.string,
  /**
   * Removed background color from child List.Item,
   */
  transparent: PropTypes.bool,
};

List.defaultProps = {
  dense: false,
  id: undefined,
  interactive: false,
  noRules: false,
  role: undefined,
  transparent: false,
};

List.displayName = 'List';

List.Item = ListItem;

export default List;
